import * as React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import {
    Translation
} from '../../features/translations/getTranslation'

const Alert = (props: any) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: any) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}))

const CustomizedSnackbars = (props: any) => {
    const classes = useStyles();
    const open = props.snackActive;
    const setOpen = props.setSnackActive;

    const handleClose = (event: any, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={props.info.type /*error, warning, info, success*/}>
                    {Translation.t(props.info.message)}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default CustomizedSnackbars